import React, { type FunctionComponent, useMemo } from 'react'
import { css } from '@emotion/react'
import { SimpleSelect, spacing } from '@retailer-platform/shared-components'
import { Button } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/partner-pick-devices/utils/domain/intl'
import { type WarehouseLocation } from 'legacy/common/types'
import { PartnerPickDeviceStatusFilterEnum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'

interface PartnerPickDevicesListFiltersProps {
  filterParams: {
    warehouseLocationId: string
    status: string
  }
  warehouseLocations: WarehouseLocation[]
  setWarehouseLocationId: (warehouseLocationId: string) => void
  setStatus: (status: string) => void
  onAdd: () => void
}

const filtersWrapper = css({
  display: 'flex',
  alignItems: 'center',
})

const whlWrapper = css({
  width: 350,
  marginRight: spacing.X12,
})

const statusWrapper = css({
  width: 200,
  marginRight: spacing.X12,
})

const addWrapper = css({
  marginLeft: 'auto',
  marginRight: spacing.X4,
})

export const PartnerPickDevicesListFilters: FunctionComponent<
  PartnerPickDevicesListFiltersProps
> = ({ filterParams, warehouseLocations, setWarehouseLocationId, setStatus, onAdd }) => {
  const messages = useDomainMessages({
    all: 'partnerPickDevicesDomain.list.status.all',
    active: 'partnerPickDevicesDomain.list.status.active',
    inactive: 'partnerPickDevicesDomain.list.status.inactive',
    add: 'partnerPickDevicesDomain.add',
  })

  const warehouseLocationOptions = useMemo(() => {
    if (warehouseLocations) {
      return warehouseLocations.map(({ id, name }) => ({
        label: name,
        value: id,
      }))
    }
  }, [warehouseLocations])

  const statusOptions: { label: string; value: string }[] = useMemo(
    () => [
      {
        label: messages.all,
        value: undefined,
      },
      {
        label: messages.active,
        value: PartnerPickDeviceStatusFilterEnum.Active,
      },
      {
        label: messages.inactive,
        value: PartnerPickDeviceStatusFilterEnum.Inactive,
      },
    ],
    [messages]
  )

  return (
    <div css={filtersWrapper}>
      <div css={whlWrapper}>
        <SimpleSelect
          onChange={setWarehouseLocationId}
          value={filterParams.warehouseLocationId}
          options={warehouseLocationOptions}
        />
      </div>

      <div css={statusWrapper}>
        <SimpleSelect onChange={setStatus} value={filterParams.status} options={statusOptions} />
      </div>

      <div css={addWrapper}>
        <Button onClick={onAdd}>{messages.add}</Button>
      </div>
    </div>
  )
}
